import { IGetLastActivitiesResponse } from "@/shared/services/interface/responses/dashboard";
import { useTranslation } from "react-i18next";
import { GetActivityTexts } from "@/features/dashboard/pages/mail/helper/list-item-helper";
import { IInbox } from "@/shared/services/interface/responses/IInboxResponses";
import React from "react";
import ActivityItem from "./activity-item";
import ActivityItemsExpandable from "./activity-items-expandible";

interface ITimeGroupItemsProps {
  groupLabel: string;
  groupData: IGetLastActivitiesResponse
}

export default function TimeGroupItems({ groupLabel, groupData }: ITimeGroupItemsProps) {
  const { t } = useTranslation();

  return (
    <div className="w-full">
      {/* Time Group Header */}
      <div
        className={`text-[11px] font-regular text-[#A1A1AA] leading-[12px] tracking-[0.22px] uppercase text-left w-full mt-[4px]`}
      >
        {groupLabel}
      </div>
      {
        groupData.map((item) => {
          const { activities, targetId } = item;
          const specificationMetadata = activities?.[0]?.metadata?.specification;
          const firstActivity = activities?.[0];

          // Create a mock IInbox object for GetActivityTexts function
          const mockInbox: IInbox = {
            id: firstActivity?.activityId || "",
            createdAt: firstActivity?.createdAt || "",
            updatedAt: firstActivity?.createdAt || "",
            deletedAt: firstActivity?.deletedAt || null,
            userId: "",
            targetId: targetId,
            type: firstActivity?.type as any,
            isFavorite: false,
            metadata: firstActivity?.metadata || {} as any,
            isRead: false,
          };

          const activityTexts = firstActivity
            ? GetActivityTexts(
              mockInbox,
              firstActivity.type as any,
              t,
              mockInbox
            )
            : null;

          return (
            <div
              key={targetId}
              className="bg-[#FAFAFA] border border-[#e4e4e7] flex flex-col gap-[4px] items-start pb-[4px] pt-0 px-0 rounded-[12px] w-full mt-[8px]"
            >
              {/* Header */}
              <div className="bg-white border-b border-[#e4e4e7] flex gap-[8px] items-center px-[12px] py-[8px] rounded-tl-[12px] rounded-tr-[12px] w-full">
                {activityTexts?.icon && (
                  <div className="size-[14px] text-[#71717A] flex items-center justify-center">
                    {React.cloneElement(activityTexts.icon, {
                      className: "size-[14px] text-[#71717A]",
                    })}
                  </div>
                )}
                <div className="text-[14px] font-[700] text-foreground leading-[20px] flex-1">
                  {specificationMetadata?.name}
                </div>
              </div>

              {/* Activity Items */}
              <div className="flex flex-col items-start px-[4px] py-0 w-full">
                <ActivityItemsExpandable activities={activities} targetId={targetId} />
              </div>
            </div>
          )
        })
      }
    </div>
  )
}